import React from 'react';
import { useHistory } from 'react-router-dom';

import { ApRadio } from '@alixpartners/ui-components';
import { FiltersSection } from './FiltersSection';
import { TableContainer } from './Table';
import { HeaderSummaryContainer } from '../HeaderSummary';
import {
	Content,
	Breadcrumbs,
	HorizontalGroup,
	RadioLabel,
	MainWrapper,
	Section,
} from './BudgetPerformance.styles';
import { CONFIG } from '../routes';
import { TABLE_DIMENSIONS } from './utils';

export const BudgetPerformance = ({
	onTableDimensionChange,
	tableDimension,
	filterModel,
	filtersList,
	onFilterModelChange,
	isFiltersLoading,
	spendFormatter,
}) => {
	const history = useHistory();

	const handleBack = () => {
		history.push({
			pathname: CONFIG[0].path,
			state: {
				primaryFilter: filterModel.primaryFilter,
				monthNumbers: filterModel.monthNumbers,
			},
		});
	};

	return (
		<Content>
			<Breadcrumbs>
				<span onClick={handleBack}>Overview</span>&nbsp;/&nbsp;<span>
					Budget Performance
				</span>
			</Breadcrumbs>
			<HorizontalGroup>
				{TABLE_DIMENSIONS.map(({ value, label }) => (
					<ApRadio
						key={value}
						name="spendType"
						value={value}
						onChange={onTableDimensionChange}
						checked={tableDimension === value}
					>
						<RadioLabel>{label}</RadioLabel>
					</ApRadio>
				))}
			</HorizontalGroup>
			<MainWrapper>
				<Section>
					<FiltersSection
						filterModel={filterModel}
						onFilterModelChange={onFilterModelChange}
						filtersList={filtersList}
						isFiltersLoading={isFiltersLoading}
					/>
				</Section>
				<Section>
					<HeaderSummaryContainer
						spendFormatter={spendFormatter}
						filterModel={filterModel}
					/>
					<TableContainer
						spendFormatter={spendFormatter}
						tableDimension={tableDimension}
						filterModel={filterModel}
					/>
				</Section>
			</MainWrapper>
		</Content>
	);
};
